<template>
    <div class="cockpit-chart">
        <!-- TÍTULO -->
        <div class="chart-title">
            <router-link
                v-if="linked"
                div="span"
                :to="{ name: 'ven-cockpit-chart', params: { tipo: datacontent.titulo } }"
            >
                {{ title }}
            </router-link>
            <div v-else>{{ title }}</div>
        </div>

        <!-- CONTEÚDO -->
        <div ref="chartContent" class="chart-content" v-if="!noData">
            <svg ref="svgcontent"></svg>
        </div>

        <!-- FOOTER -->
        <div class="chart-footer" v-if="!noData">
            <div ref="LGbox" class="legend-chart"></div>
        </div>

        <!-- MSG NÃO HÁ DADOS -->
        <div class="no-data bar" v-if="noData">
            <svg class="fail">
                <use :xlink:href="require('@/assets/img/icons/chart-error.svg') + '#layer'"></use>
            </svg>
            <div>{{ $t('chart-no-data') }}</div>
        </div>
    </div>
</template>
<script>
/**
 * @deprecated PieChart, use DonutChart instead
 *
 * @71172 - feito adaptação para o DonutChart, onde o mesmo
 * possuí agora os dois comportamentos, tanto do PieChart
 * como do mesmo.
 */
import CockpitChart from '@/components/shared/chart/CockpitChart';
import { palette as paleta } from '@/functions/color/Palette';

export default {
    extends: CockpitChart,

    props: {
        title: undefined,
        datacontent: undefined,
        linked: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            total: 0,
            dataset: [],
            cores: [],
            filtered: [],
            isAnimating: false,
            noData: false,
        };
    },
    mounted() {
        this.dataset = [...this.datacontent.items];

        if (!this.dataset || this.dataset.length <= 0) {
            this.noData = true;
        } else {
            this.dataset = this.dataset.filter((e) => {
                return e.value > 0;
            });

            this.noData = this.dataset.length < 1;

            if (!this.noData) {
                this.datacontent.items.forEach((dc) => {
                    this.total += dc.value;
                });
                this.cores = paleta.getChartColors();

                if (!this.dataset || this.dataset.length <= 0) {
                    this.noData = true;
                }

                this.drawChartWL(this.dataset);
            }
        }
    },
    watch: {
        // data: function(newData) {
        //     this.drawChart(newData);
        // }
    },
    methods: {
        drawChartWL(data) {
            let self = this;
            var d3 = this.$d3;
            var filter = this.filtered;
            var width = this.$refs.chartContent.offsetWidth;
            var height = this.$refs.chartContent.offsetHeight;
            height = width < height ? width : height;
            var margin = { top: 20, left: 0, bottom: 20, right: 0 };
            var chartWidth = width - (margin.left + margin.right);
            var chartHeight = height - (margin.top + margin.bottom);

            var color = d3.scaleOrdinal(this.cores);
            var div = d3
                .select('body')
                .append('div')
                .attr('class', 'chart-tooltip')
                .style('opacity', 0);

            var svg = d3
                .select(this.$refs.svgcontent) // select element in the DOM with id 'chart'
                .append('svg') // append an svg element to the element we've selected
                .attr('width', chartWidth) // set the width of the svg element we just added
                .attr('height', height) // set the height of the svg element we just added
                .append('g') // append 'g' element to the svg element
                .attr(
                    'transform',
                    'translate(' + chartWidth / 2 + ',' + (chartHeight / 2 + 20) + ')'
                ); // our reference is now to the 'g' element. centerting the 'g' element to the svg element

            var arc = d3
                .arc()
                .innerRadius(0) // none for pie chart
                .outerRadius(chartHeight / 2); // size of overall chart

            var pie = d3
                .pie() // start and end angles of the segments
                .value(function (d) {
                    return d.value;
                }) // how to extract the numerical data from each entry in our dataset
                .sort(null); // by default, data sorts in oescending value. this will mess with our animation so we set it to null

            data.forEach(function (d) {
                d.value = +d.value; // calculate value as we iterate through the data
                d.enabled = true; // add enabled property to track which entries are checked
                d.initvalue = d.value;
            });

            // creating the chart
            var path = svg
                .selectAll('path') // select all path elements inside the svg. specifically the 'g' element. they don't exist yet but they will be created below
                .data(pie(data)) //associate dataset wit he path elements we're about to create. must pass through the pie function. it magically knows how to extract values and bakes it into the pie
                .enter() //creates placeholder nodes for each of the values
                .append('g')
                .attr('class', 'chart-label')
                .append('path') // replace placeholders with path elements
                .attr('d', arc) // define d attribute with arc function above
                .attr('fill', function (d) {
                    return color(d.data.label);
                }) // use color scale to define fill of each label in dataset
                .attr('stroke', function (d) {
                    return color(d.data.label);
                }) // use color scale to define fill of each label in dataset
                .each(function (d) {
                    return this._current - d;
                }); // creates a smooth animation for each track

            path.on('mouseover', (d) => {
                div.transition()
                    .duration(200)
                    .style('opacity', this.legendOpacity)
                    .style('color', '#FFF');
                //   .style("background-color", "#000")
                div.html(d.data.label.split('-')[0] + ': ' + d.data.value)
                    .style('left', this.$d3.event.pageX - div.node().offsetWidth / 2 + 'px')
                    .style('top', this.$d3.event.pageY - 40 + 'px');
            })
                .on('mousemove', (d) => {
                    div.style(
                        'left',
                        this.$d3.event.pageX - div.node().offsetWidth / 2 + 'px'
                    ).style('top', this.$d3.event.pageY - 40 + 'px');
                })
                .on('mouseout', (d) => {
                    div.transition().duration(500).style('opacity', 0);
                });

            path.transition('PieChart') // transition of redrawn pie
                .duration(600) //
                .attrTween('d', function (d) {
                    // 'd' specifies the d attribute that we'll be animating
                    var interpolate = d3.interpolate(this._current, d); // this = current path element
                    this._current = interpolate(0); // interpolate between current value and the new value of 'd'
                    return function (t) {
                        let dp = arc(interpolate(t)).split('L');
                        return dp[0].split(/\,/g).length > 2 ? arc(interpolate(t)) : dp[0];
                    };
                });

            var pathtext = svg
                .selectAll('.chart-label')
                .append('text')
                .attr('transform', (d) => {
                    var _d = arc.centroid(d);
                    _d[0] *= 1.2; //multiply by a constant factor
                    _d[1] *= 1.2; //multiply by a constant factor
                    return 'translate(' + _d + ')';
                })
                .attr('dy', '.50em')
                .style('text-anchor', 'middle')
                .style('fill', function (d) {
                    return self.isColorLight(color(d.data.label)) ? '#000' : '#FFF';
                })
                .style('font-size', (d) => (this.getValue(d) < 6 ? '7px' : '9px'))
                .text((d) => {
                    if (this.getValue(d) < 4) {
                        return '';
                    }
                    return this.getFormattedValue(d);
                });

            var legends = this.$d3
                .select(this.$refs.LGbox)
                .attr('font-family', 'sans-serif')
                .attr('font-size', 10)
                .attr('text-anchor', 'end')
                .selectAll('.legend')
                .data(color.domain())
                .enter()
                .append('div')
                .attr('class', 'legend-box')
                .on('click', function (label) {
                    if (!self.isAnimating) {
                        self.isAnimating = true;

                        setTimeout(function () {
                            ff = data.map((d) => {
                                d.value = d.initvalue;
                                return d;
                            });
                            self.isAnimating = false;
                        }, 620);

                        var rect = d3.select(this); // this refers to the colored squared just clicked
                        var enabled = true; // set enabled true to default
                        var totalEnabled = d3.sum(
                            data.map(function (d) {
                                // can't disable all options
                                return d.enabled ? 1 : 0; // return 1 for each enabled entry. and summing it up
                            })
                        );

                        if (rect.attr('class') === 'disabled') {
                            // if class is disabled
                            rect.attr('class', ''); // remove class disabled
                        } else {
                            // else
                            if (totalEnabled < 2) {
                                return; // if less than two labels are flagged, exit
                            }

                            rect.attr('class', 'disabled'); // otherwise flag the square disabled
                            enabled = false; // set enabled to false
                        }

                        // Update the array to filter the chart by:

                        // add the clicked key if not included:
                        if (filter.indexOf(label) == -1) {
                            filter.push(label);
                            // if all bars are un-checked, reset:
                            if (filter.length == color.domain().length) filter = [];
                        }
                        // otherwise remove it:
                        else {
                            filter.splice(filter.indexOf(label), 1);
                        }

                        pie.value(function (d) {
                            if (d.label === label) d.enabled = enabled; // if entry label matches legend label
                            return d.enabled ? d.value : 0; // update enabled property and return value or 0 based on the entry's status
                        });

                        path = path.data(pie(data)); // update pie with new data

                        path.transition('PieChart') // transition of redrawn pie
                            .duration(600) //
                            .attrTween('d', function (d) {
                                // 'd' specifies the d attribute that we'll be animating
                                var interpolate = d3.interpolate(this._current, d); // this = current path element
                                this._current = interpolate(0); // interpolate between current value and the new value of 'd'
                                return function (t) {
                                    let dp = arc(interpolate(t)).split('L');
                                    return dp[0].split(/\,/g).length > 2
                                        ? arc(interpolate(t))
                                        : dp[0];
                                };
                            });

                        let ff = data.map((d) => {
                            if (!d.enabled) {
                                d.value = 0;
                            } else {
                                d.value = d.initvalue;
                            }
                            return d;
                        });
                        let total = 0;
                        data.forEach((f) => {
                            if (f.enabled) {
                                total += f.value;
                            }
                        });

                        pathtext
                            .data(pie(ff))
                            .transition('PieText') // transition of redrawn pie
                            .duration(600) //
                            .attrTween('transform', function (d) {
                                // var interpolate = d3.interpolate(this._current, d);
                                // var _this = this;
                                return function (t) {
                                    var _d = arc.centroid(d);
                                    _d[0] *= 1.2; //multiply by a constant factor
                                    _d[1] *= 1.2; //multiply by a constant factor
                                    return 'translate(' + _d + ')';
                                };
                            })
                            .styleTween('text-anchor', function (d) {
                                var interpolate = d3.interpolate(this._current, d);
                                return function (t) {
                                    var d2 = interpolate(t);
                                    return self.midAngle(d2) < Math.PI ? 'start' : 'end';
                                };
                            })
                            .style('opacity', function (d) {
                                if (!d.data.enabled) {
                                    return 0;
                                }
                                return 1;
                            })
                            .text((d) => {
                                if (self.getValue(d, total) < 4) {
                                    return '';
                                }
                                return self.getFormattedValue(d, total);
                            });

                        // update legend:
                        legends.style('opacity', (d) => {
                            if (filter.length) {
                                if (filter.indexOf(d) == -1) {
                                    return 1;
                                } else {
                                    return 0.4;
                                }
                            } else {
                                return 1;
                            }
                        });
                    }
                });

            legends
                .append('div')
                .style('width', this.legendRectSize + 'px')
                .style('height', this.legendRectSize + 'px')
                .attr('class', 'legend-color-box')
                .style('background', color);

            legends
                .append('p')
                .style('text-transform', 'uppercase')
                .text(function (d) {
                    return d;
                });
        },

        getValue(d, total = this.total) {
            let percent = (d.data.value * 100) / total;
            return percent;
        },
        getFormattedValue(d, total) {
            return (Math.floor(this.getValue(d, total) * 100) / 100 + ' %').replace('.', ',');
        },
        midAngle(d) {
            return d.startAngle + (d.endAngle - d.startAngle) / 2;
        },
        redrawChart() {
            if (this.datacontent.items > 0) {
                this.$d3.select(this.$refs.svgcontent).select('g').remove();
                this.$d3.select(this.$refs.LGbox).selectAll('.legend-box').remove();
                this.drawChartWL(this.dataset);
            }
        },
    },
};
</script>
